import CollapsibleSection from "components/Section";
import { Button } from "components/Button";
import React, { useCallback, useEffect, useRef, useState } from "react";
import TextValue from "components/TitleValue";
import { useTranslation } from "react-i18next";
import {
  TSubscriberWaterMeter,
  TWaterMeter,
  TWaterMeterReadingData,
  WaterMeterAlarmsType,
} from "types/dto";

import { Grid } from "components/Grid";
import { format } from "date-fns-jalali";
import { Enum2Array, EnumFlag2Array, getEnumLabels } from "utils/enumTools";
import { SortObjectByPropName } from "utils/arrayTools";
import { getJalaliDate } from "utils/dateTimeTools";

type TProps = {
  data?: TWaterMeterReadingData;
  isLoading?: boolean;
};
export const MeterAlarms = (props: TProps) => {
  const { data, isLoading } = props;

  const { t } = useTranslation();

  // const [data, setData] = useState<TWaterMeter>();
  const [isGettingData, setIsGettingData] = useState<boolean>(false);

  const gridRef = useRef(null);

  // const getMeterDetails = async (waterMeterId: string) => {
  //   setIsGettingData(true);
  //   const res: RequestResponseResult<TWaterMeter> = await netCall({
  //     method: "GET",
  //     endPoint: `${ManagementApiUrl()}/api/WaterMeter/GetWaterMeter/${waterMeterId}`,
  //   });
  //   if (res.responseCode === ResponseCode.OK) {
  //     const record = res.results;
  //     setData(record);
  //   } else {
  //     toast.error(t("errorInGettingData"));
  //   }
  //   setIsGettingData(false);
  // };

  // useEffect(() => {
  //   if (waterMeterId) {
  //     getMeterDetails(waterMeterId);
  //   }
  // }, [waterMeterId]);

  const renderAlarmsDataGrid = useCallback(() => {
    if (data?.readingData && data?.readingData?.length > 0) {
      return (
        <>
          <Grid
            ref={gridRef}
            gridKey={"id"}
            dataSource={data.readingData}
            height={292}
            columns={[
              {
                dataField: "dt",
                caption: t("date"),
                dataType: "date",
                calculateCellValue: (data: any) => {
                  return getJalaliDate({
                    date: data?.dt,
                  });
                },
                width: 150,
              },
              {
                dataField: "alarms",
                caption: t("alarms"),
                allowFiltering: false,
                allowSorting: false,
                calculateCellValue: (data: any) => {
                  const values = EnumFlag2Array(
                    WaterMeterAlarmsType,
                    data.alarms
                  );
                  const res = [];
                  if (values) {
                    for (let i = 0; i < values.length; i++) {
                      res.push(t("enum-" + WaterMeterAlarmsType[values[i]]));
                    }
                  }
                  return res.join(", ");
                },
              },
            ]}
            hasSearchPanel={false}
            hasPagination={false}
            hasGroupingFeatures={false}
            hasFilterBuilder={false}
          />
        </>
      );
    }
  }, [data]);

  return (
    <CollapsibleSection
      title={t("meterAlarms")}
      collapsible={true}
      isLoading={isLoading}
      skeleton="table"
      // className={"h-full"}
    >
      <div className={"grid grid-cols-2 gap-y-3 gap-x-6 w-full"}>
        {/*<TextValue*/}
        {/*  title={t("modelType")}*/}
        {/*  value={data?.modelType}*/}
        {/*  className={"col-span-1"}*/}
        {/*/>*/}
        {/*<TextValue*/}
        {/*  title={t("waterMeterType")}*/}
        {/*  value={data?.waterMeterType}*/}
        {/*  className={"col-span-1"}*/}
        {/*/>*/}
        {/*<TextValue*/}
        {/*  title={t("locationType")}*/}
        {/*  value={data?.locationType}*/}
        {/*  className={"col-span-1"}*/}
        {/*/>*/}
        {/*<TextValue*/}
        {/*  title={t("productionYear")}*/}
        {/*  value={data?.productionYear}*/}
        {/*  className={"col-span-1"}*/}
        {/*/>*/}
        {/*<TextValue*/}
        {/*  title={t("serialNo")}*/}
        {/*  value={data?.serialNo}*/}
        {/*  className={"col-span-1"}*/}
        {/*/>*/}
        {/*<div className="w-full col-span-2 flex items-center justify-end gap-x-2">*/}
        {/*  <Button*/}
        {/*    variant="outlined"*/}
        {/*    className={"text-error-80 border-error-80"}*/}
        {/*    onClick={onUnAssignMeterClick}*/}
        {/*  >*/}
        {/*    {t("unassignMeter")}*/}
        {/*  </Button>*/}
        {/*  <Button variant="outlined" onClick={onAssignMeterClick}>*/}
        {/*    {t("assignAnotherMeter")}*/}
        {/*  </Button>*/}
        {/*</div>*/}
      </div>
      {renderAlarmsDataGrid()}
    </CollapsibleSection>
  );
};
